// extracted by mini-css-extract-plugin
export default {"container":"root_container__hvf2g","message":"root_message__E9JSC"};